<script>
    export let short = false;
    export let ajankohtaistaUrl = "2024-08-29-kehonhuolto_jatkuu";
    let title = "Kehonhuolto ja Pilates jatkuu taas sunnuntaisin!";
    let titlePic = "/svelte-site/img/ajankohtaista/kansi-2.jpg";
    let firstPara = "Ihanat kehonhuolto- ja Pilates-tunnit jatkuvat. Tulevana sunnuntaina 1.9. alkaen joka toinen sunnuntai kehonhuolto ja Pilates alkaen 8.9. klo 18. Tervetuloa matkaan!";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <h1>{title}</h1>
                    <div class="blogMainImage" style="background-image: url('{titlePic}')"></div>
                    <p>Ihanat kehonhuolto- ja Pilates-tunnit jatkuvat taas sunnuntaisin klo 18! </p>
                    <p> Kehonhuolto ja Pilates vuorottelevat sunnuntaisin 1.9. alkaen.
                    </p>
                    <p>Tervetuloa mukaan!</p>
                    <h3>Syksyn viikko-ohjelma kokonaisuudessaan:</h3>
                    <ul>
                        <li>Maanantai: SykeKaski klo 18</li>
                        <li>Maanantai: VoimaKaski klo 19</li>
                        <li>Tiiistai: Savotta klo 18</li>
                        <li>Torstai: VoimaKaski klo 18</li>
                        <li>Torstai: SykeKaski klo 19</li>
                        <li>Lauantai: Savotta klo 11</li>
                        <li>Sunnuntai: Kehonhuolto / Pilates klo 18</li>
                    </ul>


                    <p>
                        <br>
                        Nähdään sunnuntaina!
                    </p>
                </div>

            </div>


        </article>
    </div>
{/if}

<style>


    .yhteistyossa {
        clear: both;
        font-size: 85%;
    }

    .yhteistyossa img {
        float: left;
        height: 90px;
        margin: 8px 32px 8px 0;
    }

    @media all and (max-width: 900px) {
        .yhteistyossa img {
            height: 80px;
        }
    }

</style>
